export default "__VITE_ASSET__Cw$saObP__"